export const categories = [
  { id: 'comedy', name: '搞笑视频', icon: 'ri-emotion-laugh-line', color: 'bg-accent-500', count: 12580 },
  { id: 'lifestyle', name: '生活记录', icon: 'ri-heart-line', color: 'bg-primary-500', count: 9870 },
  { id: 'talent', name: '才艺展示', icon: 'ri-magic-line', color: 'bg-secondary-500', count: 7650 },
  { id: 'food', name: '美食分享', icon: 'ri-restaurant-line', color: 'bg-accent-500', count: 6320 },
  { id: 'travel', name: '旅行风光', icon: 'ri-earth-line', color: 'bg-primary-500', count: 5490 },
  { id: 'music', name: '音乐舞蹈', icon: 'ri-music-line', color: 'bg-secondary-500', count: 8120 },
  { id: 'pet', name: '萌宠日常', icon: 'ri-camera-line', color: 'bg-accent-500', count: 4670 },
  { id: 'sports', name: '运动健身', icon: 'ri-run-line', color: 'bg-primary-500', count: 3890 },
  { id: 'tech', name: '科技数码', icon: 'ri-smartphone-line', color: 'bg-secondary-500', count: 2980 },
  { id: 'fashion', name: '时尚穿搭', icon: 'ri-t-shirt-line', color: 'bg-accent-500', count: 5210 },
  { id: 'game', name: '游戏电竞', icon: 'ri-gamepad-line', color: 'bg-primary-500', count: 7430 },
  { id: 'knowledge', name: '知识科普', icon: 'ri-lightbulb-line', color: 'bg-secondary-500', count: 3450 },
];

export const videos = [
  {
    id: 'v001',
    title: '今天在办公室笑到肚子疼！同事模仿老板讲话太像了',
    category: 'comedy',
    thumbnail: 'https://readdy.ai/api/search-image?query=Two%20Chinese%20office%20colleagues%20laughing%20hysterically%20at%20desk%2C%20one%20person%20imitating%20the%20boss%2C%20bright%20modern%20office%20with%20warm%20lighting%2C%20candid%20moment%2C%20fun%20and%20playful%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20editorial%20style&width=640&height=360&seq=qiezi-comedy-01&orientation=landscape',
    author: '搞笑小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20professional%20headshot%2C%20warm%20and%20approachable&width=96&height=96&seq=qiezi-avatar-01&orientation=squarish',
    views: '128.5万',
    likes: '8.6万',
    duration: '00:32',
    publishDate: '2026-08-09',
    description: '办公室日常搞笑合集！同事的模仿功力太强了，全办公室都笑疯了。记录那些工作中的欢乐瞬间，分享给每一个打工人！',
  },
  {
    id: 'v002',
    title: '周末早晨的第一杯咖啡，生活需要仪式感',
    category: 'lifestyle',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20person%20making%20pour-over%20coffee%20in%20a%20sunlit%20morning%20kitchen%2C%20steam%20rising%20from%20coffee%20cup%2C%20warm%20morning%20light%20through%20window%2C%20minimalist%20aesthetic%2C%20cozy%20and%20peaceful%20atmosphere%2C%20clean%20composition&width=640&height=360&seq=qiezi-lifestyle-01&orientation=landscape',
    author: '小日子记录者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20gentle%20smile%2C%20simple%20studio%20background%2C%20soft%20natural%20lighting%2C%20warm%20tones%2C%20professional%20headshot&width=96&height=96&seq=qiezi-avatar-02&orientation=squarish',
    views: '56.2万',
    likes: '3.2万',
    duration: '00:45',
    publishDate: '2026-08-08',
    description: '周末的早晨，放下手机，给自己冲一杯手冲咖啡。生活不必太匆忙，偶尔慢下来也是一种享受。',
  },
  {
    id: 'v003',
    title: '街头钢琴演奏《菊次郎的夏天》，路人纷纷驻足',
    category: 'talent',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20playing%20public%20piano%20on%20city%20street%2C%20crowd%20of%20passersby%20stopping%20to%20watch%2C%20sunlit%20urban%20plaza%2C%20warm%20evening%20light%2C%20candid%20street%20performance%2C%20beautiful%20atmosphere&width=640&height=360&seq=qiezi-talent-01&orientation=landscape',
    author: '街头钢琴师',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%2C%20artistic%20look%2C%20warm%20studio%20lighting%2C%20elegant%20style%2C%20professional%20headshot%2C%20soft%20background&width=96&height=96&seq=qiezi-avatar-03&orientation=squarish',
    views: '203.7万',
    likes: '15.3万',
    duration: '01:28',
    publishDate: '2026-08-07',
    description: '人潮涌动的街头，一架公共钢琴静静地等待着。当《菊次郎的夏天》的旋律响起，所有人都不由自主地停下了脚步。',
  },
  {
    id: 'v004',
    title: '在家自制正宗重庆小面，麻辣鲜香停不下来',
    category: 'food',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20delicious%20bowl%20of%20Chongqing%20spicy%20noodles%20on%20wooden%20table%2C%20steaming%20hot%20with%20red%20chili%20oil%2C%20fresh%20herbs%20and%20peanuts%20garnish%2C%20warm%20kitchen%20lighting%2C%20appetizing%20food%20photography%2C%20rich%20textures&width=640&height=360&seq=qiezi-food-01&orientation=landscape',
    author: '厨房里的秘密',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20chef%20portrait%2C%20warm%20smile%2C%20kitchen%20background%2C%20professional%20headshot%2C%20soft%20lighting&width=96&height=96&seq=qiezi-avatar-04&orientation=squarish',
    views: '89.1万',
    likes: '6.8万',
    duration: '02:15',
    publishDate: '2026-08-07',
    description: '不用去重庆也能吃到地道小面！手把手教你从调料到煮面，每一步都超详细，保证你能复刻出那个让人上头的味道。',
  },
  {
    id: 'v005',
    title: '隐藏在北京胡同里的绝美天台，俯瞰整座古城',
    category: 'travel',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20rooftop%20view%20of%20Beijing%20hutong%20old%20town%20at%20sunset%2C%20traditional%20grey%20tile%20roofs%2C%20warm%20golden%20hour%20light%2C%20ancient%20cityscape%20with%20modern%20skyline%20in%20distance%2C%20peaceful%20atmosphere&width=640&height=360&seq=qiezi-travel-01&orientation=landscape',
    author: '旅途中的小确幸',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20traveler%20portrait%2C%20friendly%20smile%2C%20outdoor%20background%2C%20adventurous%20style%2C%20professional%20headshot%2C%20natural%20lighting&width=96&height=96&seq=qiezi-avatar-05&orientation=squarish',
    views: '67.3万',
    likes: '4.5万',
    duration: '01:05',
    publishDate: '2026-08-06',
    description: '在北京生活了这么多年，竟然才发现这片秘境！藏在胡同深处的天台咖啡，360度无死角俯瞰京城，太适合发呆放空了。',
  },
  {
    id: 'v006',
    title: '零基础学跳《科目三》，三天速成教程来了',
    category: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20young%20dancer%20in%20bright%20dance%20studio%20doing%20popular%20dance%20move%2C%20dynamic%20pose%2C%20mirror%20wall%20reflection%2C%20energetic%20atmosphere%2C%20clean%20modern%20studio%20with%20warm%20lighting&width=640&height=360&seq=qiezi-music-01&orientation=landscape',
    author: '舞蹈达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20male%20dancer%20portrait%2C%20energetic%20expression%2C%20dance%20studio%20background%2C%20professional%20headshot%2C%20dynamic%20lighting&width=96&height=96&seq=qiezi-avatar-06&orientation=squarish',
    views: '352.1万',
    likes: '28.9万',
    duration: '03:42',
    publishDate: '2026-08-06',
    description: '全网最火的《科目三》舞蹈教程！分解动作，慢速教学，零基础也能学会。赶紧跟练起来，下次聚会你就是最靓的仔！',
  },
  {
    id: 'v007',
    title: '我家猫居然会开门！铲屎官惊呆了',
    category: 'pet',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20orange%20tabby%20cat%20jumping%20to%20reach%20door%20handle%20in%20bright%20living%20room%2C%20funny%20pet%20moment%2C%20warm%20home%20interior%20with%20sofa%20and%20plants%2C%20candid%20photography%2C%20playful%20atmosphere&width=640&height=360&seq=qiezi-pet-01&orientation=landscape',
    author: '喵星人日报',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20round%20cat%20face%20closeup%20portrait%2C%20big%20eyes%2C%20warm%20indoor%20background%2C%20soft%20natural%20light%2C%20adorable%20pet%20photography&width=96&height=96&seq=qiezi-avatar-07&orientation=squarish',
    views: '176.4万',
    likes: '12.1万',
    duration: '00:28',
    publishDate: '2026-08-05',
    description: '我家猫偷偷学会了开门技能！第一次看到的时候真的惊呆了，这猫怕不是成精了吧？各位铲屎官们，你们的猫也有这种隐藏技能吗？',
  },
  {
    id: 'v008',
    title: '每天15分钟居家燃脂训练，一个月瘦了8斤',
    category: 'sports',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20fit%20woman%20doing%20home%20workout%20exercise%20in%20bright%20living%20room%2C%20yoga%20mat%20on%20floor%2C%20morning%20sunlight%20through%20windows%2C%20healthy%20lifestyle%2C%20clean%20minimal%20interior&width=640&height=360&seq=qiezi-sports-01&orientation=landscape',
    author: '健身教练小美',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20fitness%20woman%20portrait%2C%20healthy%20glowing%20skin%2C%20sporty%20style%2C%20studio%20background%2C%20professional%20headshot%2C%20bright%20lighting&width=96&height=96&seq=qiezi-avatar-08&orientation=squarish',
    views: '98.6万',
    likes: '7.3万',
    duration: '04:20',
    publishDate: '2026-08-05',
    description: '不想去健身房？没关系！这套居家燃脂训练，每天只要15分钟，不用器械，跟着我做，一个月后你真的会感谢现在的自己！',
  },
  {
    id: 'v009',
    title: '2026年最值得入手的数码好物，学生党必看',
    category: 'tech',
    thumbnail: 'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20of%20modern%20tech%20gadgets%20on%20white%20desk%2C%20headphones%20tablet%20smartphone%20and%20accessories%2C%20minimalist%20tech%20product%20photography%2C%20bright%20clean%20lighting%2C%20warm%20aesthetic&width=640&height=360&seq=qiezi-tech-01&orientation=landscape',
    author: '数码控阿磊',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%2C%20tech%20enthusiast%20style%2C%20modern%20studio%20background%2C%20professional%20headshot%2C%20clean%20lighting&width=96&height=96&seq=qiezi-avatar-09&orientation=squarish',
    views: '145.2万',
    likes: '10.5万',
    duration: '05:18',
    publishDate: '2026-08-04',
    description: '2026年过半，我整理了这半年来用过最值得推荐的数码产品。从百元到千元档都有，学生党也能轻松入手，性价比超高！',
  },
];

export const articles = [
  {
    id: 'a001',
    title: '短视频创作入门指南：从零开始打造你的第一个爆款视频',
    category: 'knowledge',
    author: '茄子创作学院',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20educator%20portrait%2C%20friendly%20smile%2C%20studio%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=96&height=96&seq=qiezi-avatar-edu&orientation=squarish',
    publishDate: '2026-08-08',
    readTime: '8分钟',
    thumbnail: 'https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20smartphone%20and%20video%20editing%20setup%20on%20wooden%20desk%2C%20warm%20home%20office%20atmosphere%2C%20content%20creation%20concept%2C%20clean%20minimal%20aesthetic%2C%20soft%20natural%20light&width=800&height=450&seq=qiezi-article-01&orientation=landscape',
    summary: '想做短视频但不知道从哪里开始？这篇指南将从选题、拍摄、剪辑到发布，手把手教你创作出第一个吸引人的短视频作品。',
    content: [
      { type: 'heading', text: '第一步：找准你的内容定位' },
      { type: 'paragraph', text: '在开始创作之前，最重要的一步是明确你的内容方向。问问自己：你最擅长什么？你对什么最感兴趣？你的目标观众是谁？一个清晰的内容定位，会让你的创作之路事半功倍。比如你喜欢做饭，那就专注于美食内容；你擅长搞笑，就走幽默路线。找准定位后，你的粉丝增长会更有方向感。' },
      { type: 'heading', text: '第二步：掌握基础的拍摄技巧' },
      { type: 'paragraph', text: '拍摄设备不需要太专业，一部手机就足够开始。关键是要注意以下几点：光线要充足，尽量使用自然光；画面要稳，可以买个便宜的手机支架；构图要简洁，不要放太多元素。记住，内容永远比器材重要。很多爆款视频都是用手机拍出来的！' },
      { type: 'heading', text: '第三步：学会基础剪辑' },
      { type: 'paragraph', text: '剪辑是让视频更精彩的魔法棒。你不需要学会所有的剪辑技巧，掌握这几个就够了：裁剪掉多余的片段、添加背景音乐、加上简单的字幕。现在的剪辑软件都很友好，比如剪映、快影等，几分钟就能上手。记住，节奏感是短视频的灵魂！' },
      { type: 'heading', text: '第四步：发布和互动' },
      { type: 'paragraph', text: '视频做好后，选一个流量较好的时间段发布（一般是晚上7-10点）。发布时记得写一个吸引人的标题，加上相关的标签。发布后要积极回复评论，和粉丝互动。数据不好也不要灰心，每个大V都是从零开始的，坚持就是胜利！' },
    ],
  },
  {
    id: 'a002',
    title: '2026年短视频行业趋势报告：这些赛道正在爆发',
    category: 'knowledge',
    author: '茄子研究院',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20analyst%20portrait%2C%20serious%20expression%2C%20office%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=96&height=96&seq=qiezi-avatar-research&orientation=squarish',
    publishDate: '2026-08-05',
    readTime: '12分钟',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20data%20analytics%20dashboard%20display%20with%20charts%20and%20graphs%2C%20trending%20upward%20lines%2C%20warm%20office%20environment%2C%20professional%20analytics%20concept%2C%20clean%20minimal%20aesthetic&width=800&height=450&seq=qiezi-article-02&orientation=landscape',
    summary: '2026年短视频行业持续增长，AI创作、虚拟人直播、本地生活等新赛道正在爆发。了解趋势，抓住机遇，让你的创作走在时代前沿。',
    content: [
      { type: 'heading', text: 'AI赋能创作，效率革命来袭' },
      { type: 'paragraph', text: '2026年，AI工具在短视频创作领域的应用越来越广泛。从AI写脚本、AI配音到AI生成画面，创作者的生产效率大幅提升。以前需要一天才能完成的视频，现在可能两小时就能搞定。但要注意，AI是工具不是替代品，独特创意和个人风格仍然是核心竞争力。' },
      { type: 'heading', text: '本地生活赛道持续升温' },
      { type: 'paragraph', text: '随着短视频平台不断加码本地生活业务，探店、旅游攻略、本地服务推荐等内容迎来了爆发式增长。这个赛道的优势在于竞争相对较小、变现路径清晰。如果你热爱探索身边的好店好去处，现在正是入局的好时机。' },
      { type: 'heading', text: '知识付费进入黄金期' },
      { type: 'paragraph', text: '用户对高质量知识内容的需求越来越旺盛。从职场技能到生活百科，知识类短视频的播放量和转化率都在持续上升。如果你在某个领域有专长，不妨尝试做知识分享，既能帮助别人，又能建立自己的个人品牌。' },
      { type: 'heading', text: '互动式内容成为新宠' },
      { type: 'paragraph', text: '传统的单向内容已经不能满足用户需求，带有投票、选择题、剧情分支等互动元素的短视频正在成为新宠。这种内容形式能极大提升用户的参与感和停留时长，是2026年最值得尝试的创新方向。' },
    ],
  },
];

export const faqItems = [
  { question: '茄子视频是什么？', answer: '茄子视频是一款集搞笑、生活、才艺、美食等多种内容为一体的短视频娱乐平台。用户可以在平台上观看海量精彩视频、发现有趣内容、记录和分享生活瞬间。我们致力于为每一位用户提供优质的短视频观看体验。' },
  { question: '茄子视频如何下载？', answer: '您可以通过本网站的下载按钮直接下载茄子视频APP，也可以在苹果App Store或各大安卓应用市场搜索"茄子视频"进行下载。下载完全免费，安装后即可开始观看精彩内容。' },
  { question: '茄子视频有哪些特色功能？', answer: '茄子视频提供个性化推荐算法，根据您的观看偏好智能推送感兴趣的内容。支持高清视频播放、离线缓存、弹幕互动、创作工具等功能。同时还有丰富的话题挑战和社区互动玩法。' },
  { question: '如何在茄子视频上发布自己的作品？', answer: '下载茄子视频APP后，注册并登录账号，点击底部的"+"按钮即可进入创作模式。您可以选择拍摄新视频或从相册上传。我们的创作工具提供丰富的滤镜、特效和音乐，让您轻松制作出精彩的短视频作品。' },
  { question: '茄子视频的使用是免费的吗？', answer: '茄子视频的基础功能完全免费，包括观看视频、发布内容、互动评论等。我们致力于为所有用户提供优质的免费娱乐体验。部分增值服务（如去除广告、专属标识等）可能需要付费订阅，但不会影响核心使用体验。' },
  { question: '如何联系茄子视频客服？', answer: '您可以通过以下方式联系我们：发送邮件至contact@qiezitv.com，或拨打客服热线400-888-8888（工作时间：周一至周五 9:00-18:00）。在APP内也可以通过"我的-帮助与反馈"联系在线客服。' },
];